import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';

interface IProps {
  target: number | '-';
  currentValue: number | '-';
  subtext: string;
  unit: string;
  t: (str: string, object?: { [key: string]: string }) => string;
}

export function ChallengeInfoDisplay({
  target, subtext, unit, currentValue,
}: IProps) {
  return (
    <View style={styles.container}>
      <View style={{ marginBottom: defaultScale(6) }}>
        <View style={styles.row}>
          <View style={styles.textContainer}>
            <Text style={styles.weightText}>{`${currentValue}`}</Text>
            <Text style={styles.lightText}>
              /
              {`${target}${unit}`}
            </Text>
          </View>
          <View style={styles.arrowContainer}>
            <Icon
              size={defaultScale(18)}
              color={Theme.GREY_DARK_MEDIUM}
              name='ios-arrow-forward'
            />
          </View>
        </View>
        <Text style={styles.subText}>{subtext}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  weightText: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(24),
    color: Theme.BLACK,
  },
  lightText: {
    display: 'flex',
    fontFamily: Theme.Weight500,
    fontSize: scaleText(16),
    color: Theme.GREY,
    alignSelf: 'flex-end',
    paddingBottom: defaultScale(2),
  },
  textContainer: {
    flexDirection: 'row',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  subText: {
    marginTop: 2,
    ...Theme.textStyle.small,
  },
  arrowContainer: {
    alignSelf: 'center',
  },
  container: {
    height: defaultScale(76),
    paddingHorizontal: defaultScale(18),
    backgroundColor: Theme.WHITE,
    justifyContent: 'center',
    alignContent: 'center',
    borderWidth: defaultScale(0.4),
    borderColor: Theme.GREY,
  },
});
